import axios from 'axios';

// API INSTANCE
export default axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  // timeout: 1000,
});
